import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'formik';

import ProfileInput from '../../form/ProfileInput';
import AuthSubmitButton from '../common/AuthSubmitButton';

import Alert from '../../common/Alert';

const LoginForm = props => {
  return (
    <Form noValidate>
      {props.errors.summary && <Alert message={props.errors.summary} isError isSmall />}
      <Field name="username" component={ProfileInput} placeholder="Email" disabled={props.isSubmitting} />
      <Field
        name="password"
        type="password"
        component={ProfileInput}
        placeholder="Password"
        disabled={props.isSubmitting}
      />
      <AuthSubmitButton title="Login" isSubmitting={props.isSubmitting} />
    </Form>
  );
};

LoginForm.propTypes = {
  errors: PropTypes.object.isRequired, // TODO shape
  isSubmitting: PropTypes.bool.isRequired,
};

export default LoginForm;
